// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__278L7","inner":"styles_inner__2F9Ll","right":"styles_right__3csvx","close":"styles_close__25s_T","footer":"styles_footer__2c4cJ"};